import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-12 w-12 rounded-2xl bg-indigo-50 border border-indigo-100 text-indigo-600 flex items-center justify-center" }
const _hoisted_2 = { class: "space-y-1" }
const _hoisted_3 = { class: "py-4 space-y-3" }
const _hoisted_4 = { class: "space-y-2" }

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import DMSuiteIcon from "@/components/iconify/DMSuiteIcon.vue";
import { DASHBOARD_ICONS } from "@/config/dashboardIcons";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportDownloadPreviewModal',
  props: {
    open: { type: Boolean },
    report: {}
  },
  emits: ["update:open", "confirm"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

function close() {
  emit("update:open", false);
}

function confirm() {
  emit("confirm");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: __props.open,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => (emit('update:open', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), { class: "max-w-md rounded-3xl p-6 bg-white shadow-2xl border border-slate-100 text-left" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), { class: "space-y-3" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(DMSuiteIcon, {
                  icon: _unref(DASHBOARD_ICONS).eventReport,
                  size: 24,
                  "custom-class": "text-indigo-600"
                }, null, 8, ["icon"])
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(DialogTitle), { class: "text-lg font-black text-slate-800" }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" Download Monthly Report ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), { class: "text-xs text-slate-400 font-semibold leading-relaxed" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Prepare and download the comprehensive marketing performance summary for " + _toDisplayString(__props.report?.report_period) + ". ", 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-sm font-extrabold text-slate-700" }, " This report includes: ", -1)),
            _createElementVNode("ul", _hoisted_4, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
              'Service progress summary',
              'Service health diagnostics',
              'Completed tasks breakdown',
              'Pending client action status',
              'Package performance indicators',
              'Latest update trail and logs'
            ], (item) => {
                return _createElementVNode("li", {
                  key: item,
                  class: "flex items-center gap-2 text-xs text-slate-500 font-semibold"
                }, [
                  _createVNode(DMSuiteIcon, {
                    icon: _unref(DASHBOARD_ICONS).check,
                    size: 16,
                    "custom-class": "text-emerald-500 shrink-0"
                  }, null, 8, ["icon"]),
                  _createTextVNode(" " + _toDisplayString(item), 1)
                ])
              }), 64))
            ])
          ]),
          _createVNode(_unref(DialogFooter), { class: "grid grid-cols-2 gap-3 pt-2" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                variant: "outline",
                class: "w-full rounded-xl font-bold text-xs py-3 border-slate-200 text-slate-500 hover:bg-slate-50",
                onClick: close
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" Cancel ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_unref(Button), {
                class: "w-full rounded-xl bg-indigo-600 text-white font-bold text-xs py-3 hover:bg-indigo-700 flex items-center justify-center gap-1.5 shadow-md shadow-indigo-600/10 active:scale-98 transition duration-200",
                onClick: confirm
              }, {
                default: _withCtx(() => [
                  _createVNode(DMSuiteIcon, {
                    icon: _unref(DASHBOARD_ICONS).download,
                    size: 16
                  }, null, 8, ["icon"]),
                  _cache[4] || (_cache[4] = _createTextVNode(" Download PDF ", -1))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})